import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GaTrackingPdpOfferMismatchEvent implements GATrackingEvent {

  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PdpOfferMismatch;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.PdpOfferMismatch,
      label: this.payload.productID,
      gtmCustom: {
        selectedOfferID: this.payload.selectedOfferID,
        marketingFeedOfferID: this.payload.feedOfferID,
        marketingFeedSource: this.payload.feedSource
      }
    };
  }
}
